import React, { useMemo, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {invoiceAmountDue } from '../../../utility/features/helpers/accountHelper';
import { IsLoggedIn } from "../../../utility/features/helpers/authHelper";
import AccountDetailsClient from "../../../utility/apiClients/account/accountDetailsClient";
import customerSummaryClient from "../../../utility/apiClients/customer/customerSummaryClient";
import { getDataFromLocalStorage } from "../../../utility/features/helpers/accountHelper";
import Storage from "../../../utility/features/helpers/storageHelper";
import Loader from "../../loader";
import { setCustomerDetails } from "../../../reduxStore/myAccount/getCustomerDetails";

import {
  setAccountDetails,
  setDisplayPrePayButton,
  setDisplayEasyPayButton,
  setIsOverlayLoading,
} from "../../../reduxStore/myAccount/accountSummarySlice";
import { Link, useNavigate } from "react-router";
import Globals, { URLS } from "../../../utility/constants/appConstants";
import ServiceAgreement from "../../myAccount/payments/serviceAgreements";
import NoServiceAgreement from "./noServiceAgreement";

import { setCustomerInfo } from "../../../reduxStore/login/loginSlice";
import paymentStatusClient from '../../../utility/apiClients/payments/paymentStatusClient';
import missionStatusClient from '../../../utility/apiClients/user/missionStatusClient';
import "../../../styles/myAccount/accountSummary.module.css";
import accountSummaryCss from "../../../styles/myAccount/accountSummary.module.scss";
import store from "../../../reduxStore/store";
import { Pagination } from "../../Pagination";
import "../../../styles/pagination.css";
import ErrorBlock from '../../errorMessage';
import localGlobals from "../../../json/fallbackglobalvariables.json";

const AccountSummary = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();

  const refSqftMapModal = useRef(null);
  
  const [queryString, setQueryString] = useState(
    window.location.search != "" ? window.location.search : ""
  );
  const labels = Globals.acc;
  const [customerSummary, setCustomerSummary] = useState(store.getState().login.customerInfo);
  const accDetails = useSelector((state) => state.accountSummary.details);
  const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);

  const selectedServiceAddress = useSelector(
    (state) => state.accountSummary.selectedServiceAddress
  );
  const addressSelectionTimestamp = useSelector(
    (state) => state.accountSummary.addressSelectionTimestamp
  );
  const custNumbers = JSON.parse(localStorage.getItem("customerNumbers")) || [];
  
  const [serviceAddress, customerNumber] = useMemo(() => {
    let custNumber = "";
    let serviceAddr = "";
    if(selectedServiceAddress != null){
      [serviceAddr, custNumber] = selectedServiceAddress.split(" | ");
    } else {
      custNumber = customerSummary?customerSummary[0].CustomerNumber:custNumbers[0];
      serviceAddr = customerSummary?customerSummary[0].ServiceAddresses[0].address:"";
    }
    
    return [serviceAddr, custNumber];
  }, [selectedServiceAddress, customerSummary]);

  const [missionDown, setMissionDown] = useState(false);
  const [isActiveCustomer, setIsActiveCustomer] = useState(true);
  const [inActiveMessage, setInActiveMessage] = useState("");
  
  const [isLoading, setIsLoading] = useState(true);

  const [accountData, setAccountData] = useState(accDetails);
  const [unauthorizeResponse, setUnauthorizeResponse] = useState(false);
  const [lawnDetails, setLawnDetails] = useState({
    address: "",
    lawnAreas: [],
    totalAreaSqftValue: -1,
  });

  const [addressByCust, setAddressByCust] = useState([]);
  const [csError, setCsError] = useState("");

  const [invoiceStatuses, setInvoiceStatuses] = useState({
      processing: [],
      failed: [],
      success: [],
      not_found: [],
      onqueue: [],
      pending:[]
  });

  const [allInvoices, setAllInvoices] = useState([]);

  const [page, setPage] = useState(1);
  const pageSize = 10;

  const totalItems = accountData && accountData.serviceAgreements ? accountData.serviceAgreements.length : 0;
  const showPagination = totalItems > pageSize;

  const pageData = useMemo(() => {
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    return accountData && accountData.serviceAgreements
      ? accountData.serviceAgreements.slice(start, end)
      : [];
  }, [accountData, page, pageSize]);
  

  const missionStatusCheck = async () => {
    try {
      const missionStatus = await missionStatusClient();
      return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
    } catch (err) {
      console.error("Error checking mission status api:", err);
      return false;
    }
  };

  const AccountDetailsApiCallRef = useRef(false);
  const CustomerDetailsApiCallRef = useRef(customerNumber);

  useEffect(() => {
    if(CustomerDetailsApiCallRef.current != customerNumber) {
      CustomerDetailsApiCallRef.current = customerNumber;
      setCustomerSummary(null);
    }
  }, [customerNumber]);
  
  
  useEffect(() => {    
    setCsError("");
    if (serviceAddress && customerNumber) {
      (async () => {
        //await getCustomerSummary(customerNumber);
        if(allCustomersApiCalled) {
          const isMissionAvailable = await missionStatusCheck();
          console.log("Mission status on account details api call line no 140: ", isMissionAvailable);
          if (!isMissionAvailable) {
            setMissionDown(true);
            setIsLoading(false);
            setCsError(localGlobals.acc.missionDownErrorDisplay);
            return;
          }
          await fetchAccountDetails(customerNumber, serviceAddress);
        }
      })();
    }

    return () => {
      setIsLoading(true);
      setCsError("");
    }
  }, [customerSummary, selectedServiceAddress, addressSelectionTimestamp, allCustomersApiCalled]);

  const getCustomerSummary = async (custNum) => {
    if(custNum === "") return;

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setMissionDown(true);
      setIsLoading(false);
      setCsError(localGlobals.acc.missionDownErrorDisplay);
      return;
    }

    setIsLoading(true);
    setCsError("");

    try {
      const customerSummary = await customerSummaryClient(custNum);

      if (customerSummary?.status && customerSummary?.status === 401 ) {
          console.log("Unauthorized access - 401");
          localStorage.clear();
          nav("/login", { replace: true });
          return;
      }
        
      if (
        customerSummary?.data === null ||
        customerSummary?.data === undefined
      ) {
        setCsError("Some error occurred.");
        return;
      }
      
      dispatch(setCustomerInfo(customerSummary?.data));
      setCustomerSummary([customerSummary?.data]);
      setAddressByCust(customerSummary?.data?.ServiceAddresses || []);
    } catch (err) {
      setCsError("Some error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    if (page > totalPages) setPage(totalPages);
  }, [page]);

  useEffect(() => {
    if(allInvoices.length > 0){
      (async () => await checkPaymentStatus())();
    } 
  }, [allInvoices]);

  const fetchAccountDetails = async (customerNumber, serviceAddress) => {
    setIsLoading(true);
    try {
      const response = await AccountDetailsClient(
        customerNumber,
        serviceAddress
      );
      
      if (
        response?.CODE === "ER" &&
        response?.DESCRIPTION === "NO ACTIVE CUSTOMER INFORMATION"
      ) {
        setIsActiveCustomer(false);
        setInActiveMessage(response.DESCRIPTION);
        
        return;
      }

      if (response && !response.errorMsg) {
         dispatch(setCustomerDetails(response));
        
        const accData = getDataFromLocalStorage(response);

        let activeServiceAgreements = [];
        accData?.serviceAgreements.forEach(invoice => {
            // if sales agreement has bad debt, do not show invoice
            if (invoice.isBadSalesAgreement !== 'N' && invoiceAmountDue(invoice) > 0 && invoice.inactiveReason !== 'SSP' && invoice.inactiveReason !== 'NRN') return null;
            
            if(invoice?.Invoices.length > 0){
              invoice?.Invoices.forEach(inv => {
                  if (inv.invoiceBalance > 0 && inv.invoiceOpen === "Y") {
                    activeServiceAgreements.push({
                        payTotalPymt: inv.invoiceBalance,
                        salesAgrNum: inv?.salesAgrNum,
                        invoiceNo: inv?.invoiceNum,
                        invoiceAmt: inv?.invoiceBalance,
                        payBunit: invoice?.asgBunit,
                        svcLineDesc: inv?.svcServiceLine,
                        dueDate: inv?.invoiceDate,
                    });
                  }
              });
            }
        });

        // Remove duplicates from activeServiceAgreements based on invoiceNo
        const uniqueActiveServiceAgreements = activeServiceAgreements.filter((item, index, self) =>
            index === self.findIndex((t) => t.invoiceNo === item.invoiceNo)
        );

        setAllInvoices(uniqueActiveServiceAgreements);

        dispatch(setAccountDetails(accData));
        dispatch(
          setDisplayPrePayButton(
            response?.SalesAgreementVer5PPEPList?.[0]?.dspPPSignupButton === "Y"
          )
        );
        dispatch(
          setDisplayEasyPayButton(
            response?.SalesAgreementVer5PPEPList?.[0]?.dspEPSignupButton === "Y"
          )
        );

        if(uniqueActiveServiceAgreements.length == 0){
          setIsLoading(false);
        }
        
      } else if (response?.errorStatus === 401) {
        // Flag unauthorized → handle in effect below
        setUnauthorizeResponse(true);
      } else if (response?.errorStatus === 424) {
        setCsError("Some error occurred.");
        console.log("424 error occured.");
      } else {
        throw response?.errorMsg ? new Error(response.errorMsg) : new Error("Some error occurred.");
      }
    } catch (err) {
      if(err && err?.message !== "signal is aborted without reason")
        setCsError(`Some error occurred.`);
    }
  };

  const checkPaymentStatus = async () => {
    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setMissionDown(true);
      setIsLoading(false);
      setCsError(localGlobals.acc.missionDownErrorDisplay);
      return;
    }

    setIsLoading(true);
    const allPaidInvoices = allInvoices.map(sa => ({ invoiceNumber: sa.invoiceNo, saNumber: sa.salesAgrNum }));

    try {
        const response = await paymentStatusClient(allPaidInvoices);
            
        if (response?.error) {
            setCsError("Some error occurred.");
        } else if (response?.data) {
            // Process the payment status response
            const processing = [];
            const failed = [];
            const success = [];
            const not_found = [];
            const onqueue = [];
            const pending = [];
          
            response?.data.forEach(item => {
                const invoiceNumber = item.invoice_number;
                const status = item.status.toLowerCase();

                if (status === 'processing' || status === 'in-progress') {
                    processing.push(invoiceNumber);
                } else if (status === 'failed') {
                    failed.push(invoiceNumber);
                } else if (status === 'success') {
                    success.push(invoiceNumber);
                }else if (status === 'not_found') {
                    not_found.push(invoiceNumber);
                }else if (status === 'onqueue') {
                    onqueue.push(invoiceNumber);
                }else if (status === 'pending') {
                    pending.push(invoiceNumber);
                }
            });

            setInvoiceStatuses({ processing, failed, success, not_found, onqueue, pending });
            
        } else {
            setCsError("Some error occurred.");
        }
    } catch (err) {
        console.error('Error checking payment status:', err);
        setCsError("Some error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accDetails) {
      setAccountData(accDetails);
    }
  }, [accDetails]);

  useEffect(() => {
    if (!IsLoggedIn() || unauthorizeResponse) {
      (async () => {
        await Storage.logoutUser();
        window.location = "/login";
      })();
    }

    if (customerSummary == null) {
      (async () => {
        await getCustomerSummary(custNumbers[0]);
      })();
    }

  }, [unauthorizeResponse, customerSummary]); 

  const { yourPlanSvc, noPlansServices, addSvc, pre, pay, andSave, missionDownErrorDisplay } = labels;
  
  return (
    <>
      {/* {missionDown && csError == "" && <ErrorBlock labels={labels} errMsg={missionDownErrorDisplay} />} */}

      {csError != "" && <ErrorBlock labels={labels} errMsg={csError} />}

      {csError == "" && isLoading && <Loader />}

      {csError == "" && !isLoading && !isActiveCustomer && <>Inactive: {inActiveMessage}</>}

      {csError == "" && !isLoading && accountData && accountData.serviceAgreements && (
        <>
          <div
            className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["mb-40"]} p-md-30 tru-mma-main-wrapper ${accountSummaryCss["tru-mma-main-wrapper--summary"]}`}
          >
            <div className={`container-fluid`}>
              <div className={`row`}>
                <div
                  className={`col-12 ${accountSummaryCss["gfs-20"]} ${accountSummaryCss["mb-20"]} p-0`}
                >
                  <span className={`${accountSummaryCss["gfw-3"]}`}>
                    {yourPlanSvc}
                  </span>
                  &nbsp;
                  
                  <span className={`${accountSummaryCss["gfw-7"]} text-uppercase`} >
                    {!selectedServiceAddress && addressByCust?.[0]?.address
                    ? addressByCust?.[0]?.address
                    : selectedServiceAddress !== null
                      ? selectedServiceAddress.split(" | ")?.[0] || ""
                      : document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[0] || ""
                    }
                  </span>
                </div>
              </div>

              {pageData && pageData.length > 0 ? (
                <>
                  {pageData.map((serviceAgreement, i) => {
                    return (
                      <React.Fragment key={`${serviceAgreement.Id}-${i}`}>
                        <ServiceAgreement
                          serviceAgreement={serviceAgreement}
                          sqftMapModalRef={refSqftMapModal}
                          uri={window.location.pathname}
                          setAccountSummaryState={(obj) => setLawnDetails(obj)}
                          labels={labels}
                          setIsOverlayLoading={(bool) =>
                            dispatch(setIsOverlayLoading(bool))
                          }
                          paymentsCss={accountSummaryCss}
                          invoiceStatuses={invoiceStatuses}
                        />
                      </React.Fragment>
                    );
                  })}

                  {showPagination && <div className={`pagination-container`}>
                    <Pagination
                      currentPage={page}
                      totalItems={totalItems}
                      pageSize={pageSize}
                      onPageChange={setPage}
                      maxButtons={7}
                    />
                   </div>
                  }
                </>
              ) : (
                <NoServiceAgreement noPlansServices={noPlansServices} />
              )}
            </div>
          </div>

          <div className={`${accountSummaryCss["content"]} d-none d-md-block`}>
            <div className={`row ${accountSummaryCss["glh-1_5"]}`}>
              <Link
                className={`align-items-stretch col-6 d-flex ${accountSummaryCss["mb-40"]} ${accountSummaryCss["text-dark"]}`}
                to={`/my-account/payments${queryString?"/"+queryString:""}`}
              >
                <div
                  className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["p-20"]} ${accountSummaryCss["tru-mma-main-grid-block"]} w-100`}
                >
                  <span
                    className={`d-block ${accountSummaryCss["gfs-22"]} ${accountSummaryCss["gfs-lg-26"]} ${accountSummaryCss["mb-20"]}`}
                  >
                    Payments
                  </span>
                  <ul className={`${accountSummaryCss["g-font-size-16"]}`}>
                    <li>
                      <span>View billing history</span>
                    </li>
                    <li>
                      <span>PrePay for services</span>
                    </li>
                    <li>
                      <span>Enroll in EasyPay</span>
                    </li>
                  </ul>
                </div>
              </Link>
              <Link
                className={`align-items-stretch col-6 d-flex ${accountSummaryCss["mb-40"]} ${accountSummaryCss["text-dark"]}`}
                to={`/my-account/my-services${queryString?"/"+queryString:""}`}
              >
                <div
                  className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["p-20"]} ${accountSummaryCss["tru-mma-main-grid-block"]} w-100`}
                >
                  <span
                    className={`d-block ${accountSummaryCss["gfs-22"]} ${accountSummaryCss["gfs-lg-26"]} ${accountSummaryCss["mb-20"]}`}
                  >
                    Service Details
                  </span>
                  <ul className={`${accountSummaryCss["g-font-size-16"]}`}>
                    <li>
                      <span>Service history</span>
                    </li>
                    <li>
                      <span>Remaining services</span>
                    </li>
                  </ul>
                </div>
              </Link>
              <Link
                className={`align-items-stretch col-6 d-flex ${accountSummaryCss["mb-40"]} ${accountSummaryCss["text-dark"]}`}
                to={`/my-account/account-settings${queryString?"/"+queryString:""}`}
              >
                <div
                  className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["p-20"]} ${accountSummaryCss["tru-mma-main-grid-block"]} w-100`}
                >
                  <span
                    className={`d-block ${accountSummaryCss["gfs-22"]} ${accountSummaryCss["gfs-lg-26"]} ${accountSummaryCss["mb-20"]}`}
                  >
                    Account Settings
                  </span>
                  <ul className={`${accountSummaryCss["g-font-size-16"]}`}>
                    <li>
                      <span>Change password</span>
                    </li>
                    <li>
                      <span>Manage payment methods</span>
                    </li>
                  </ul>
                </div>
              </Link>
              <Link
                className={`align-items-stretch col-6 d-flex ${accountSummaryCss["mb-40"]} ${accountSummaryCss["text-dark"]}`}
                to={`/my-account/my-documents${queryString?"/"+queryString:""}`}
              >
                <div
                  className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["p-20"]} ${accountSummaryCss["tru-mma-main-grid-block"]} w-100`}
                >
                  <span
                    className={`d-block ${accountSummaryCss["gfs-22"]} ${accountSummaryCss["gfs-lg-26"]} ${accountSummaryCss["mb-20"]}`}
                  >
                    My Documents
                  </span>
                  <ul className={`${accountSummaryCss["g-font-size-16"]}`}>
                    <li>
                      <span>Service summaries</span>
                    </li>
                    <li>
                      <span>Invoices</span>
                    </li>
                  </ul>
                </div>
              </Link>
            </div>
          </div>
        </>
      )}

      {csError == "" && !isLoading && !isActiveCustomer && (
        <div
          className={`${accountSummaryCss["bg-gray-100"]} ${accountSummaryCss["mb-40"]} p-md-30 tru-mma-main-wrapper ${accountSummaryCss["tru-mma-main-wrapper--summary"]}`}
        >
          <div className="container-fluid">
            <div className="row">
              <div
                className={`col-12 ${accountSummaryCss["gfs-20"]} ${accountSummaryCss["mb-20"]} p-0`}
              >
                <span
                  className={`${accountSummaryCss["gfw-7"]} text-uppercase`}
                >
                  {inActiveMessage}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {csError == "" && !isLoading && accountData && accountData.prePaydiscAmt > 0 && (
        <Link
          to={URLS.prePayPayment + queryString}
          className={`align-items-center ${accountSummaryCss["bg-yellow"]} d-flex ${accountSummaryCss["gfs-24"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["glh-1"]} justify-content-center ${accountSummaryCss["mb-20"]} ${accountSummaryCss["p-16"]} text-decoration-none text-center tru-mma-mobile-margins text-white`}
        >
          <div>
            <span className="font-italic">
              <strong className={`${accountSummaryCss["gfw-7"]}`}>{pre}</strong>
              {pay}
            </span>
            {andSave}
            {Globals.currencySymbol}
            {parseFloat(accountData.prePaydiscAmt).toFixed(2)}
          </div>
        </Link>
      )}
    </>
  );
};

export default AccountSummary;
